import { render, staticRenderFns } from "./MerchantPointAvailableModal.vue?vue&type=template&id=f283cb54&scoped=true&"
import script from "./MerchantPointAvailableModal.vue?vue&type=script&lang=js&"
export * from "./MerchantPointAvailableModal.vue?vue&type=script&lang=js&"
import style0 from "./MerchantPointAvailableModal.vue?vue&type=style&index=0&id=f283cb54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f283cb54",
  null
  
)

export default component.exports